import { combineReducers } from "@reduxjs/toolkit";
import localTracks from "./local-tracks/slice";
import remoteParticipants from "./remote-participants/slice";
import mediaDevices from "./media-devices/slice";
import errors from "./errors/slice";
import user from "./user/slice";
import room from "./room/slice";
import sync from "./sync/slice";
import chatMessages from "./chat-messages/slice";

const rootReducer = combineReducers({
  localTracks,
  remoteParticipants,
  mediaDevices,
  errors,
  user,
  room,
  sync,
  chatMessages
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
